<template>
  <div style="min-height: 100%;">
    <router-view class="view" style="min-height: calc(100vh - 305px);"></router-view>
    <Footer/>
  </div>
</template>

<script>

import Footer from "./templates/Footer";
export default {
  name: "App",
  components: {
    Footer
  },
  metaInfo() {
        return { 
            title: "Létající pivovar HoppyHedgehog",
            meta: [
                { vmid:'description', name: 'description', content:  'Létající pivovar HoppyHedgehog'},
                { vmid: 'author', name: 'author', content:  'Adam Klíma'},
                { vmid:'og:image', property: 'og:image', content: "https://hoppyhedgehog.cz/assets/img/logo.svg"},
                { vmid:'og:type', property: 'og:type', content: 'text/html' },
                { vmid:'fb:app_id', property: 'fb:app_id', content: '693625164608416' },
                { vmid: 'robots', name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>
